import React from "react";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import "../component/Togrther.css";

function Togrther() {
  return (
    <div className="together">
      <p className="need">NEED A DEVELOPER?</p>
      <a href="https://www.linkedin.com/in/pijush-ray-mondal-621980192/">
        {" "}
        <p className="work_together">
          Let’s work together{" "}
          <span className="mobileQ">
            {" "}
            &nbsp;
            <KeyboardDoubleArrowRightIcon sx={{ fontSize: 34 }} />
          </span>
          <span className="desktopQ">
            &nbsp;
            <KeyboardDoubleArrowRightIcon sx={{ fontSize: 64 }} />
          </span>
        </p>
      </a>
    </div>
  );
}

export default Togrther;
